var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Config = OCS.Config || {};
OCS.Functions.define_config_datasets = function () {
    return {
        "edu.ou.mesonet.standard": {
            "dataset": "edu.ou.mesonet.standard",
            "datatype": "netcdf",
            "node_path": "/org.mesonet/edu.ou.mesonet.standard",
            "node_args": "/{type}/{parm}/{units}",
            "name": "Mesonet",
            "node": true,
            "node_dataset": "edu.ou.mesonet.standard",
            "provider": "org.mesonet",
            "gridded_avail": true,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/map_netcdf/{dataset}/{var}/{units}/{date}/{grid}",
            "dataUrls":  {
                "timeseries_netcdf": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/timeseries_netcdf/station/{stid}/{var_settings}/{date_settings}/{other}",
                "map_netcdf": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/map_netcdf/{dataset}/{var}/{units}/{date}/{grid}"
            },
            "dataGriddedURL": "grid/true/",
            "dataQueryURL": "",
            "resolution": 300000,
            "stale_threshold": 900000
        },
        "edu.ou.ocs.ars": {
            "dataset": "edu.ou.ocs.ars",
            "datatype": "netcdf",
            "name": "ARS",
            "node": false,
            "gridded_avail": true,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/map_netcdf/{dataset}/{var}/{units}/{date}/{grid}",
            "dataGriddedURL": "grid/true/",
            "dataQueryURL": "",
            "resolution": 300000,
            "stale_threshold": 900000
        },
        "edu.ou.ocs.fcars": {
            "dataset": "edu.ou.ocs.fcars",
            "datatype": "netcdf",
            "name": "FCARS",
            "node": false,
            "gridded_avail": true,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/map_netcdf/{dataset}/{var}/{units}/{date}/{grid}",
            "dataGriddedURL": "grid/true/",
            "dataQueryURL": "",
            "resolution": 300000,
            "stale_threshold": 900000
        },
        "edu.ou.ocs.nwc": {
            "dataset": "edu.ou.ocs.nwc",
            "datatype": "netcdf",
            "name": "NWC",
            "node": false,
            "gridded_avail": true,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/map_netcdf/{dataset}/{var}/{units}/{date}/{grid}",
            "dataGriddedURL": "grid/true/",
            "dataQueryURL": "",
            "resolution": 300000,
            "stale_threshold": 900000
        },
        "edu.ou.ocs.asos": {
            "dataset": "edu.ou.ocs.asos",
            "datatype": "mdf",
            "name": "ASOS",
            "node": false,
            "gridded_avail": true,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/mdf/dataset/edu.ou.ocs.asos/date/{date}/var/{var}/units/{units}/{grid}",
            "dataGriddedURL": "grid/true/",
            "resolution": 3600000,
            "stale_threshold": 7200000
        },
        "edu.ou.ocs.advisories": {
            "dataset": "edu.ou.ocs.advisories",
            "datatype": "advisories",
            "node_path": "/gov.noaa/wwa",
            "node_args": "/{wfo}",
            "node_dataset": "wwa",
            "provider": "gov.noaa",            
            "name": "Advisories",
            "node": true,
            "gridded_avail": false,
            "dataURL": "{protocol}//data.mesonet.org/data/public/noaa/text/archive",
            "dataQueryURL": "{protocol}//{ocs_feeds_domain}/advisories?proj={proj}{wfo_param}{date_params}&format=geojson",
            "dataPolygonURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/xshp",
            "resolution": -1,
            "stale_threshold": 900000,
            "filtered_wfo_ids": []
        },
        "edu.ou.ocs.lightning": {
            "dataset": "edu.ou.ocs.lightning",
            "datatype": "lightning",
            "node_path": "/com.wdtinc/lightning",
            "node_args": "/{state}",
            "node_dataset": "lightning",
            "provider": "com.wdtinc",            
            "name": "Lightning",
            "node": true,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/regional_lightning/zone_and_reproject/1/format/geojson/date/{date}",
            "dataQueryURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/find/lightning/start/{start}/end/{end}",
            "resolution": 300000,
            "stale_threshold": 900000
        },
        "edu.ou.ocs.nids": {
            "dataset": "edu.ou.ocs.nids",
            "datatype": "nids",
            "node_path": "/gov.noaa/nexrad.level3",
            "node_args": "/{site}/{parm}",
            "node_dataset": "nexrad.level3",
            "provider": "gov.noaa",
            "name": "NEXRAD",
            "node": true,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_feeds_domain}/data/radar/realtime/level3/{year}/{month}/{day}/{radar_id}/{product}/{formatdate}{product}_{radar_id}.nids",
            "dataQueryURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/find/radar/site/{site}/prod/{product}/start/{start}/end/{end}",
            "resolution": -1,
            "stale_threshold": 900000
        },
        "gov.noaa.ncep.hpc.qpf": {
            "dataset": "gov.noaa.ncep.hpc.qpf",
            "datatype": "spckml",
            "name": "HPC Quantitative Precipitation Forecasts",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/hpc_qpf/type/{type}",
            "resolution": 1,
            "stale_threshold": -1
        },
        "gov.noaa.ncep.wpc.winter": {
            "dataset": "gov.noaa.ncep.wpc.winter",
            "datatype": "spckml",
            "name": "WPC Winter Weather Forecasts",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/wpc_winter/type/{type}",
            "resolution": 1,
            "stale_threshold": -1
        },
        "gov.noaa.spc.md": {
            "dataset": "gov.noaa.spc.md",
            "datatype": "spckml",
            "name": "SPC Mesoscale Discussions",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/spc_md/md/{md}",
            "dataQueryURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/find/spc_md",
            "resolution": 1,
            "stale_threshold": -1
        },
        "gov.noaa.spc.fwody": {
            "dataset": "gov.noaa.spc.fwody",
            "datatype": "spckml",
            "name": "SPC Fire Weather Outlooks",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/spc_fwody/day/{day}",
            "resolution": 1,
            "stale_threshold": -1
        },
        "gov.noaa.spc.stormreports": {
            "dataset": "gov.noaa.spc.stormreports",
            "datatype": "spckml",
            "name": "SPC Storm Reports",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/spc_stormreports/day/{day}",
            "resolution": 1,
            "stale_threshold": -1
        },
        "gov.noaa.spc.swody": {
            "dataset": "gov.noaa.spc.swody",
            "datatype": "spckml",
            "name": "SPC Severe Weather Outlooks",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/spc_swody/day/{day}/prod/{prod}",
            "resolution": 1,
            "stale_threshold": -1
        },
        "gov.noaa.nssl.wdssii": {
            "dataset": "gov.noaa.nssl.wdssii",
            "datatype": "spckml",
            "name": "NOAA Satellite",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/nssl_wdssii",
            "resolution": 1,
            "stale_threshold": -1
        },
        "edu.ou.ocs.usshapes": {
            "dataset": "edu.ou.ocs.usshapes",
            "datatype": "shapefile",
            "name": "US Shape Files",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//sdg.mesonet.org/weathersoft/datasets/edu.ou.ocs.usshapes/info/shapeinfo.xml",
            "dataQueryURL": "{protocol}//sdg.mesonet.org/weathersoft/datasets/edu.ou.ocs.usshapes/data/{data_unit}/{data_unit}{data_var}.shp",
            "resolution": 1,
            "stale_threshold": -1
        },
        "org.mesonet.okfirst.shapes": {
            "dataset": "org.mesonet.okfirst.shapes",
            "datatype": "shapefile",
            "name": "OK First Shape Files",
            "node": false,
            "gridded_avail": false,
            "dataURL": "{protocol}//sdg.mesonet.org/weathersoft/datasets/org.mesonet.okfirst.shapes/info/shapeinfo.xml",
            "dataQueryURL": "{protocol}//sdg.mesonet.org/weathersoft/datasets/org.mesonet.okfirst.shapes/data/{data_unit}/_{data_unit}{data_var}.shp",
            "dataPolygonURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/xshp",
            "resolution": 1,
            "stale_threshold": -1
        },
        "edu.ou.ocs.countyroads.oklahoma": {
            "dataset": "edu.ou.ocs.countyroads.oklahoma",
            "datatype": "shapefile",
            "name": "Roads",
            "node": false,
            "gridded_avail": false,
            "dataURL": "",
            "dataQueryURL": "",
            "resolution": 1,
            "stale_threshold": -1
        },
        "edu.ou.mesonet.fake": {
            "dataset": "edu.ou.mesonet.fake",
            "datatype": "netcdf",
            "node_path": "edu.ou/mesonet_fake",
            "name": "Fake",
            "node": true,
            "gridded_avail": true,
            "dataURL": "{protocol}//{ocs_api_subdomain}.{ocs_domain}/index.php/product/map_fake/dataset/edu.ou.mesonet.standard/var/{data_var}/units/{data_unit}/date/{timestamp}/",
            "dataGriddedURL": "grid/true/",
            "dataQueryURL": "",
            "resolution": 60000, //300000,
            "stale_threshold": 900000
        }
    };
};

OCS.Config.datasets = OCS.Functions.define_config_datasets();